module.exports = "<card>\r\n\t<discount-list [(placeId)]=\"placeId\" [(discounts)]=\"place.discounts\"></discount-list>\r\n</card>"